import React from 'react';

import { useTheme } from '../../theme';
import AiPurchasePredictionItem, { Props } from './AiPurchasePredictionItem/AiPurchasePredictionItem';
import ModalX from '../../BaseComponents/ModalX';

const AiPurchasePredictionService: React.FC<Props> = props => {
	const { AIPurchasePredictionService: theme } = useTheme('AIPurchasePredictionService');

	if (!props.service) {
		return null;
	}

	return (
		<ModalX
			isOpen={!!props.service}
			classes={{
				paper: theme.paper,
				dialogContent_root: theme.modal
			}}
		>
			<AiPurchasePredictionItem {...props} />
		</ModalX>
	);
};

export default AiPurchasePredictionService;
